import React, { memo, useState, useRef, Fragment } from 'react'
import { FormControlLabel, Checkbox } from '@maas-components/core'
import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import { isNumber } from 'core/common/utils/is'
import { StyledCardGroup } from '../../style'
import { TStockDetail, TStockChannels } from '../../types'
import StockChannel from '../StockChannel'

type TStockChannelsComponent = {
  channels: TStockChannels[]
  variation: string
  variationIndex?: number
  onChange: () => void
  fulfillmentLink?: string
}

const StockChannels = ({
  channels,
  variation,
  variationIndex,
  onChange,
  fulfillmentLink,
}: TStockChannelsComponent) => {
  const [isSameStock, setIsSameStock] = useState(false)
  const { setFieldValue } = useFormikContext()
  const variationPrefix = isNumber(variationIndex) ? `variations.${variationIndex}.` : ''

  const initialStock = channels.map(channel => ({
    reserved: 0,
    quantity: 0,
    name: 'Magalu',
    channel,
    branch: variation,
    type: 'on_seller',
  }))

  console.log(initialStock)

  const stocks = useRef<TStockDetail[]>([
    {
      reserved: 0,
      quantity: 0,
      name: 'Magalu',
      channel: 'magazineluiza',
      branch: 'ULA01',
      type: 'on_seller',
    },
  ])

  const toggleSameStock = () => setIsSameStock(state => !state)

  const handleInputChange = (
    channel: TStockChannels,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newArray = stocks.current.map(stock => {
      if (stock.channel === channel) {
        // eslint-disable-next-line radix
        return { ...stock, quantity: parseInt(event.target.value) }
      }
      return stock
    })

    setFieldValue(`${variationPrefix}stocks`, newArray)

    onChange()

    stocks.current = newArray
  }

  return (
    <>
      {stocks.current.length > 1 ? (
        <FormControlLabel
          className="mb-4"
          control={<Checkbox checked={isSameStock} />}
          label={i18n.t('productNew.stock.sameStock')}
          onChange={() => toggleSameStock()}
          value={isSameStock}
        />
      ) : null}
      <StyledCardGroup>
        {stocks.current.map(stock => (
          <>
            <StockChannel
              key={stock?.channel}
              name={stock?.name}
              channel={stock?.channel}
              isMultiChannel={stocks.current.length > 1}
              handleInputChange={handleInputChange}
              variationIndex={variationIndex}
              fulfillmentLink={fulfillmentLink}
            />
          </>
        ))}
      </StyledCardGroup>
    </>
  )
}

export default memo(StockChannels)
